import type { Permission } from '@idc-forms/permissions'
import useAuth from '@/features/auth/hooks/use-auth'
import type { TypeAccount } from '@/features/users/models/user'
import { usePermissions } from '@/shared/hooks/use-permissions'

interface CanProps {
  permission?: Permission | Permission[]
  allowedAccounts?: TypeAccount[]
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function Can({ permission, allowedAccounts, children, fallback = null }: CanProps) {
  const { has, hasAny } = usePermissions()
  const { auth } = useAuth()

  if (!permission && (!allowedAccounts || allowedAccounts.length === 0)) return children

  let allowed = false

  if (permission) {
    allowed = Array.isArray(permission) ? hasAny(permission) : has(permission)
  }

  if (!allowed && allowedAccounts && allowedAccounts.length > 0 && auth?.typeAccount) {
    allowed = allowedAccounts.includes(auth.typeAccount)
  }

  return allowed ? children : fallback
}
